import { randomString } from '@perch-labs/warbler';
import { FileRejection } from 'react-dropzone';

export const toBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result!.toString());
    reader.onerror = error => reject(error);
  });
};

export const dataUrlToFile = (dataUrl: string, fileName: string, mimeType: string): File => {
  const base64Content = dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl;
  const binary = atob(base64Content);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  return new File([bytes], fileName, { type: mimeType });
};

export interface UploadedImage extends File {
  id: string;
  error?: string;
  uploadId?: number;
  base64Image?: string;
  docName?: string;
}

// NB: instances of File cannot be spread like traditional objects - need to use Object.assign
export const addFileProps = (item: File | FileRejection, base64Image?: string): UploadedImage => {
  if ('errors' in item) {
    const rejection = item;
    return Object.assign(rejection.file, {
      id: randomString(10),
      error: rejection.errors[0].code,
      docName: rejection.file.name,
    });
  } else {
    const file = item;
    return Object.assign(file, {
      id: randomString(10),
      base64Image,
      docName: file.name,
    });
  }
};

export const availableDocumentTypesPerUtility = {
  2387: ['Medicaid', 'SNAP', 'Section 8', 'Free/reduced school lunch letter', 'Medicare D-SNP'], // dominion
  2336: ['LIHEAP'], // Central Hudson
  2340: ['Medicaid', 'SNAP', 'Section 8', 'LIHEAP'], // National Grid NY
  2459: ['Medicaid', 'SNAP', 'Section 8'], // NYSEG
  2902: ['LIHEAP'], // Orange and Rockland
  2287: [
    'Medicaid',
    'SNAP',
    'Section 8',
    'LIHEAP',
    'Free/reduced school lunch letter',
    'MD Energy Assistance Program',
    'Headstart',
    'HCVP',
  ], // PEPCO MD
  2289: [
    'Medicaid',
    'SNAP',
    'Section 8',
    'LIHEAP',
    'Free/reduced school lunch letter',
    'MD Energy Assistance Program',
    'Headstart',
    'HCVP',
  ], // Baltimore Gas & Electric
  2441: ['Medicaid', 'SNAP', 'Section 8'], // Ameren IL
  2269: ['Medicaid', 'SNAP', 'Section 8'], // ComEd
  2293: ['Medicaid', 'SNAP', 'Section 8', 'Free/reduced school lunch letter'], // Central Maine Power
};

// This function is for flexibilty of name of the proof-doc in drop down
// so that proof doc name in drop down can be housing_choice_voucher_program
// but its value should be as hcvp
export const updateLmiDocName = (docName: string): string => {
  switch (docName) {
    case 'Housing Choice Voucher Program':
      return 'hcvp';
    case 'Supplemental Security Income (SSI)':
      return 'ssi';
    case 'Special Supplemental Nutrition Program (WIC)':
      return 'wic';
    default:
      return docName;
  }
};
